<script setup lang="ts">
defineProps({
  object: {
    type: Object as PropType<Sanity.Default.Schema.Quote>,
    required: true,
  },
  dark: {
    type: Boolean,
    default: false,
  },
})

const { urlFor } = useSanityImage()
</script>

<template>
  <div v-if="object && object.quote" class="container-8xl">
    <div
      class="max-w-3xl"
      :class="{
        wrap: !dark,
      }"
    >
      <nuxt-img
        src="/logomark.png"
        alt="Butler Sherborn logomark"
        width="24"
        height="24"
        quality="85"
        loading="lazy"
        class="mb-4"
        :class="{
          'filter invert grayscale brightness-0 opacity-90': dark,
        }"
      />
      <div
        class="text-2xl lg:text-3xl font-semibold leading-tight"
        :class="{
          'text-white': dark,
          'text-gray-700': !dark,
        }"
      >
        &ldquo;{{ object.quote }}&rdquo;
      </div>
      <div class="mt-3 flex gap-2 items-center">
        <nuxt-img
          v-if="object.authorImage"
          :src="urlFor(object.authorImage.asset._ref).height(50).width(50).url()"
          :alt="object.authorImage.alt"
          class="rounded-full w-10 h-10"
          quality="85"
          loading="lazy"
        />
        <div
          :class="{
            'text-forest-50': dark,
            'text-gray-700': !dark,
          }"
        >
          <span class="font-semibold text-lg">{{ object.author }}</span>
          <span
            class="ml-1.5 text-sm"
            :class="{
              'text-forest-100': dark,
              'text-gray-400': !dark,
            }"
          >
            {{ object.authorDetails }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
